export default __webpack_public_path__ + "static/media/Estimated Production.fa0313c2.svg";